import React, { useState, useEffect } from 'react';
import { isTablet } from 'react-device-detect';

import './App.css';

import { hourglass } from 'ldrs';
import { bouncyArc } from 'ldrs';

import CanvasEffect from './Canvas.js';
import Main from './mainPage/Main.js';
import ShowPlace from './showPlacePage/ShowPlace.js';

import aboutMeFolder from './asset/aboutMeIcon.svg';
import aboutMeFolderGrey from './asset/aboutMeIcon_grey.svg';
import worksFolder from './asset/worksIcon.svg';
import worksFolderGrey from './asset/worksIcon_grey.svg';
import linksFolder from './asset/linksIcon.svg';
import linksFolderGrey from './asset/linksIcon_grey.svg';
import contactFolder from './asset/contactIcon.svg';
import contactFolderGrey from './asset/contactIcon_grey.svg';

import linksAndContactFolder from './asset/links_and_contact_icon.svg';
import linksAndContactFolderGrey from './asset/links_and_contact_icon_grey.svg';

import thisWebsite from "./asset/thisWebsite.svg";
// import thisWebsiteForTablet from "./asset/thisWebsiteForTablet.svg";

import loading from "./asset/loading...svg";

import preLoadImages from './PreLoad.js';

function App() {
  const [isImageClicked, setIsImageClicked] = useState(false);
  const [usbPosition, setUsbPosition] = useState(-5); // 올라오기 전의 위치

  const [showBlueScreen, setShowBlueScreen] = useState(false);
  
  const [showAboutMeModal, setShowAboutMeModal] = useState(false);
  const [showWorksModal, setShowWorksModal] = useState(false);
  const [showLinksModal, setShowLinksModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const [showLinksAndContactModal, setShowLinksAndContactModal] = useState(false);

  const [currentMenu, setCurrentMenu] = useState(null);

  const [currentAboutMeIcon, setCurrentAboutMeIcon] = useState(aboutMeFolder);
  const [currentWorksIcon, setCurrentWorksIcon] = useState(worksFolder);
  const [currentLinksIcon, setCurrentLinksIcon] = useState(linksFolder);
  const [currentContactIcon, setCurrentContactIcon] = useState(contactFolder);

  const [currentLinksAndContactIcon, setCurrentLinksAndContactIcon] = useState(linksAndContactFolder);

  const [isBlocked, setIsBlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태 관리

  const [isDragging, setIsDragging] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);
  const [showDragAndDropImage, setShowDragAndDropImage] = useState(false);

  // dotWave.register();
  hourglass.register();
  bouncyArc.register();

  useEffect(() => {
    // 모든 이미지 로드 프로미스 생성
    const imagePromises = preLoadImages.map((src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = reject;
      });
    });

    // 모든 이미지 로드 완료 시 로딩 상태 변경
    Promise.all(imagePromises)
      .then(() => setIsLoading(false))
      .catch((err) => {
        console.error('이미지 로딩 실패:', err);
        setIsLoading(false); // 에러 발생 시에도 로딩 상태 해제
      });
  }, []);

  useEffect(() => {
    const detectDevice = () => {
      const width = window.innerWidth;
      const userAgent = navigator.userAgent.toLowerCase();
      const maxTouchPoints = navigator.maxTouchPoints || 0;

      // 모바일 감지: 너비 <= 1024
      const isMobileDevice = width <= 1024;

      // 태블릿 감지:
      // 1. react-device-detect 라이브러리를 사용하는 경우
      // 2. 추가적으로 iPadOS 13 이상 감지
      const isTabletDevice = isTablet || (userAgent.includes('macintosh') && maxTouchPoints > 1);

      return isMobileDevice || isTabletDevice;
    };

    if (detectDevice()) {
      setIsBlocked(true);
    }

    // 창 크기 변경 시 다시 감지 (선택 사항)
    const handleResize = () => {
      if (detectDevice()) {
        setIsBlocked(true);
      } else {
        setIsBlocked(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const resetModals = () => {
    setShowAboutMeModal(false);
    setShowWorksModal(false);
    setShowLinksModal(false);
    setShowContactModal(false);

    setShowLinksAndContactModal(false);
  };

  const resetIcons = () => {
    setCurrentAboutMeIcon(aboutMeFolder);
    setCurrentWorksIcon(worksFolder);
    setCurrentLinksIcon(linksFolder);
    setCurrentContactIcon(contactFolder);

    setCurrentLinksAndContactIcon(linksAndContactFolder);

    setCurrentMenu(null);
  };

  const handleMenuClick = (menu) => {
    setIsImageClicked(true);
    // setUsbPosition((window.innerHeight -  (window.innerHeight / 2.12)) * 0.0451);
    setUsbPosition(48);

    resetIcons();
    
    if (menu === 'aboutMe') {
        setCurrentMenu('aboutMe');
        setCurrentAboutMeIcon(aboutMeFolderGrey);
    } else if (menu === 'works') {
        setCurrentMenu('works');
        setCurrentWorksIcon(worksFolderGrey);
    } else if (menu === 'links') {
        setCurrentMenu('links');
        setCurrentLinksIcon(linksFolderGrey);
    } else if (menu === 'contact') {
        setCurrentMenu('contact');
        setCurrentContactIcon(contactFolderGrey);
    } else if (menu === 'linksAndContact') {
        setCurrentMenu('linksAndContact');
        setCurrentLinksAndContactIcon(linksAndContactFolderGrey);
    }
  };

  const handleFolderDoubleClick = (menu) => {
    if (currentMenu !== menu) {
        resetModals();
        resetIcons();

        setCurrentMenu(menu);
        setShowBlueScreen(true);

        if (menu === 'aboutMe') {
            setShowAboutMeModal(true);
            setCurrentAboutMeIcon(aboutMeFolderGrey); // 아이콘을 회색으로 변경
        } else if (menu === 'works') {
            setShowWorksModal(true);
            setCurrentWorksIcon(worksFolderGrey); // 아이콘을 회색으로 변경
        } else if (menu === 'links') {
            setShowLinksModal(true);
            setCurrentLinksIcon(linksFolderGrey); // 아이콘을 회색으로 변경
        } else if (menu === 'contact') {
            setShowContactModal(true);
            setCurrentContactIcon(contactFolderGrey); // 아이콘을 회색으로 변경
        } else if (menu === 'linksAndContact') {
            setShowLinksAndContactModal(true);
            setCurrentLinksAndContactIcon(linksAndContactFolderGrey); // 아이콘을 회색으로 변경
        }
    } else {
    // console.log(`${menu} is already selected`);
    }
  };

const handleBackToMenuClick = () => {
  setShowAboutMeModal(false);
  setShowWorksModal(false);
  setShowLinksModal(false);
  setShowContactModal(false);

  setShowLinksAndContactModal(false);

  setShowBlueScreen(false);

  setIsImageClicked(false);

  resetIcons();

  setIsDragging(false);
  setAnimationComplete(false);
  setShowDragAndDropImage(false);

  setTimeout(() => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }); // 페이지 아래로 스크롤
  }, 300); // 모달 닫힌 후 300ms 뒤에 스크롤
};

if (isLoading) {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <div className="spinner">
        {/* <l-dot-wave
          size="47"
          speed="1" 
          color="black" 
        ></l-dot-wave> */}

        <l-hourglass
          size="40"
          bg-opacity="0.1"
          speed="1.75" 
          color="#b59bd2" 
        ></l-hourglass>
        <img 
          src={loading}
          alt="loading"
          style={{
            width: "250px",
            height: "auto",
            marginTop: "50px"
          }}
        />
      </div>
    </div>
  );
}

  return (
    <div className="app">
      <div className="aspect-container">
        <div className="aspect-inner">
          {!isBlocked ? (
            <div>
                <CanvasEffect
                  style={{
                    pointerEvents: "auto",
                    position: "fixed"
                  }}
                />
                <Main
                  isImageClicked={isImageClicked}
                  usbPosition={usbPosition}
                  setUsbPosition={setUsbPosition}
                  handleMenuClick={handleMenuClick}
                  currentMenu={currentMenu}
                  
                  setShowBlueScreen={setShowBlueScreen}
          
                  setShowAboutMeModal={setShowAboutMeModal}
                  setShowWorksModal={setShowWorksModal}
                  setShowLinksModal={setShowLinksModal}
                  setShowContactModal={setShowContactModal}

                  setShowLinksAndContactModal={setShowLinksAndContactModal}

                  isDragging={isDragging}
                  setIsDragging={setIsDragging}
                  animationComplete={animationComplete}
                  setAnimationComplete={setAnimationComplete}
                  showDragAndDropImage={showDragAndDropImage}
                  setShowDragAndDropImage={setShowDragAndDropImage}
                />
                <ShowPlace
                  showBlueScreen={showBlueScreen}
                  
                  showAboutMeModal={showAboutMeModal}
                  showWorksModal={showWorksModal}
                  showLinksModal={showLinksModal}
                  showContactModal={showContactModal}

                  showLinksAndContactModal={showLinksAndContactModal}
                  
                  setShowAboutMeModal={setShowAboutMeModal}
                  setShowWorksModal={setShowWorksModal}
                  setShowLinksModal={setShowLinksModal}
                  setShowContactModal={setShowContactModal}

                  setShowLinksAndContactModal={setShowLinksAndContactModal}
          
                  currentAboutMeIcon={currentAboutMeIcon}
                  currentWorksIcon={currentWorksIcon}
                  currentLinksIcon={currentLinksIcon}
                  currentContactIcon={currentContactIcon}
                  
                  currentLinksAndContactIcon={currentLinksAndContactIcon}
          
                  handleFolderDoubleClick={handleFolderDoubleClick}
                  handleBackToMenuClick={handleBackToMenuClick}

                  resetIcons={resetIcons}
                />
            </div>
          ) : (
            <div className="this-website-container">
              <l-bouncy-arc
                size="70"
                speed="1.65" 
                color="#1983e3"
              ></l-bouncy-arc>
              <img 
                src={thisWebsite}
                alt="this-website-is-optimized-for-desktop-use"
                style={{
                  width: "70vw",
                  height: "auto",
                  maxHeight: "80vh"
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;